import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { RequestStatus } from '../model/request-status';

@Injectable({
    providedIn: 'root'
  })
  export class RequestStatusService{
  

    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllRequestStatus() 
    {
      return this._restClientService.load<RequestStatus[]>('request-status/requeststatuses');
    }
    
  
}      

    